export const useRedirectStore = defineStore(
  'redirect',
  () => {
    const router = useRouter()

    // const { navigate } = useCommon()
    const { storedCMDStack } = storeToRefs(useMessageStore())
    const partnersKey = computed<string>(() =>
      String(router.currentRoute.value.params.partner || '')
    )
    const partnerLogin = useCookie('partnerLogin').value ?? null
    const redirectPath = ref<string | undefined>()
    // const { userData } = storeToRefs(useUserData())

    const { navigate } = useCommon()

    // useRuntimeConfig는 Nuxt 컨텍스트가 필요하므로 스토어 셋업에서 미리 잡아둔다.
    // (isInternalUrl은 로그인 후 async 콜백에서 불려서 컨텍스트가 없을 수 있다)
    const config = useRuntimeConfig()

    const isInternalUrl = (url: string) => {
      // 상대 경로(`/path`, `path`, `?q=...`)는 모두 내부 URL
      if (!/^https?:\/\//i.test(url)) {
        return true
      }

      // 절대 URL 은 현재 접속한 origin 이거나 설정된 baseUrl 이면 내부로 본다.
      // 운영은 접속 host(www.usimsa.com)와 baseUrl(usimsa.com)이 서로 달라서 둘 다 허용해야 한다.
      try {
        const target = new URL(url).origin
        return target === useRequestURL().origin || target === config.public.baseUrl
      } catch {
        return false
      }
    }

    const returnTo = (url: string) => {
      if (isInternalUrl(url)) {
        // navigateTo는 origin 일치 여부와 무관하게 프로토콜이 포함된 문자열이면 external:true를 요구하므로
        // 같은 origin인 절대 URL은 상대 경로(pathname+search+hash)로 변환해서 넘긴다

        try {
          const target = new URL(url, useRequestURL().origin)
          return navigateTo(`${target.pathname}${target.search}${target.hash}`, { replace: true })
        } catch {
          return navigateTo(url, { replace: true })
        }
      }
      return navigateTo(url, { external: true })
    }

    const redirect = (_isFirstLogin?: boolean) => {
      const route = useRoute()
      const returnUrl = route.query.returnUrl as string | undefined
      const eventUrl = route.query.eventUrl as string | undefined
      const targetUrl = returnUrl || eventUrl

      // if (userData.value?.consents === null) {
      //   // 기존 회원 마케팅 수신 동의 유도
      //   navigate(
      //     `/user/alarm/consent${targetUrl ? `?returnUrl=${targetUrl}` : ''}`,
      //     partnersKey.value,
      //     { replace: true }
      //   )
      //   return
      // }
      if (targetUrl) {
        return returnTo(targetUrl)
      }
      if (redirectPath.value) {
        storedCMDStack.value.push('welcome')
        // window.location.replace(redirectPath.value)
        navigateTo(redirectPath.value, { replace: true })
        redirectPath.value = undefined
      } else if (partnerLogin) {
        navigate('/', partnerLogin, { replace: true })
      } else {
        storedCMDStack.value.push('welcome')
        navigate('/', partnersKey.value, { replace: true })
      }
      useCookie('partnerLogin').value = null
    }

    return {
      redirectPath,
      redirect,
      returnTo
    }
  },
  {
    persist: true
  }
)
